import {library} from '@fortawesome/fontawesome-svg-core';
import {
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faBars,
    faChartBar,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronUp,
    faClock,
    faClone,
    faColumns,
    faEraser,
    faFileDownload,
    faFilter,
    faInfoCircle,
    faPencilAlt,
    faPlus,
    faPowerOff,
    faSignOutAlt,
    faSpinner,
    faSyncAlt,
    faThLarge,
    faTimes,
    faTrash,
    faTrashAlt,
    faUpload,
    faUser
} from '@fortawesome/free-solid-svg-icons';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {checkState} from './account/action/accountActions';
import AppRoutes from './AppRoutes';
import Footer from './common/component/Footer';
import Loader from './common/component/Loader';
import ScrollToTop from './common/component/ScrollToTop';
import TopBar from './common/component/TopBar';
import MessageClearer from './message/component/MessageClearer';

/**
 * @return {JSX.Element}
 */
function App() {
    const dispatch = useDispatch();
    const checkedState = useSelector(state => state.account.checkedState);

    useEffect(() => {
        dispatch(checkState());
    }, []);

    if (!checkedState) {
        return null;
    }

    // Initialize icon library
    library.add(faArrowDown, faArrowUp, faChevronDown, faClone, faChevronUp, faPlus, faPencilAlt, faTrashAlt, faTimes, faInfoCircle, faClock, faSignOutAlt,
        faCheck, faUpload, faBars, faFilter, faUser, faCheckCircle, faPowerOff, faFileDownload, faSpinner, faArrowRight, faArrowLeft, faChartBar, faThLarge,
        faTrash, faColumns, faSyncAlt, faEraser);

    return (
        <>
            <Loader/>
            <BrowserRouter basename={process.env.root}>
                <ScrollToTop/>
                <MessageClearer/>
                {/*<Header/>*/}
                <TopBar/>
                <AppRoutes/>
                <Footer/>
            </BrowserRouter>
        </>
    );
}

export default App;
